(function () {
  var cartEl = document.getElementById("nn-cart");
  var bodyEl = document.getElementById("nn-cart-body");
  var footEl = document.getElementById("nn-cart-foot");
  var subEl = document.getElementById("nn-cart-subtotal");
  var scrim = document.getElementById("nn-cart-scrim");
  var currency = (window.NN_CART && window.NN_CART.currency) || "INR";

  function money(cents) {
    try {
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: currency,
        maximumFractionDigits: 0,
      }).format(cents / 100);
    } catch (e) {
      return "₹" + Math.round(cents / 100);
    }
  }

  function countEls(n) {
    [].slice.call(document.querySelectorAll("[data-cart-count]")).forEach(function (el) {
      el.textContent = n;
      el.hidden = n < 1;
    });
  }

  function openCart() {
    if (!cartEl) return;
    cartEl.hidden = false;
    if (scrim) scrim.hidden = false;
    document.body.classList.add("nn-cart-open");
  }
  function closeCart() {
    document.body.classList.remove("nn-cart-open");
    if (cartEl) cartEl.hidden = true;
    if (scrim) scrim.hidden = true;
  }

  function render(cart) {
    if (!bodyEl) return;
    countEls(cart.item_count || 0);
    if (!cart.items || !cart.items.length) {
      bodyEl.innerHTML =
        '<div class="nn-cart-empty"><p>Your bag is empty.</p><a href="/collections/instant-noodles">Shop noodles</a></div>';
      if (footEl) footEl.hidden = true;
      return;
    }
    bodyEl.innerHTML = cart.items
      .map(function (item) {
        var img = item.image || (item.featured_image && item.featured_image.url) || "";
        return (
          '<div class="nn-cart-line" data-key="' +
          item.key +
          '">' +
          (img ? '<img src="' + img + '" alt="">' : "") +
          '<div class="nn-cart-meta"><a href="' +
          item.url +
          '">' +
          item.product_title +
          "</a><em>" +
          money(item.final_line_price) +
          '</em><div class="nn-cart-qty">' +
          '<button type="button" data-qty="-1" aria-label="Less">−</button>' +
          "<span>" +
          item.quantity +
          "</span>" +
          '<button type="button" data-qty="1" aria-label="More">+</button>' +
          '<button type="button" class="nn-cart-remove" data-qty="0">Remove</button>' +
          "</div></div></div>"
        );
      })
      .join("");
    if (subEl) subEl.textContent = money(cart.total_price);
    if (footEl) footEl.hidden = false;
  }

  function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) {
      return r.json();
    });
  }
  function refresh() {
    return getCart().then(render);
  }

  function change(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(render);
  }

  function add(id, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: Number(id), quantity: quantity || 1 }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return refresh().then(openCart);
    });
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-open]")) {
      e.preventDefault();
      refresh().then(openCart);
    }
    if (e.target.closest("[data-cart-close]")) closeCart();
    var line = e.target.closest(".nn-cart-line");
    if (line && e.target.closest("[data-qty]")) {
      var delta = e.target.getAttribute("data-qty");
      var span = line.querySelector(".nn-cart-qty span");
      var cur = span ? parseInt(span.textContent, 10) : 1;
      var next = delta === "0" ? 0 : cur + parseInt(delta, 10);
      if (next < 0) next = 0;
      change(line.getAttribute("data-key"), next);
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeCart();
  });

  document.addEventListener("click", function (e) {
    var combo = e.target.closest("[data-combo-add]");
    if (!combo) return;
    e.preventDefault();
    var ids = (combo.getAttribute("data-combo-add") || "")
      .split(",")
      .map(function (id) { return id.replace(/\D/g, ""); })
      .filter(Boolean);
    if (!ids.length) return;
    combo.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({
        items: ids.map(function (id) {
          return { id: Number(id), quantity: 1 };
        }),
      }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("combo");
        return refresh().then(openCart);
      })
      .catch(function () {})
      .then(function () {
        combo.disabled = false;
      });
  });

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute("action") || "";
    if (action.indexOf("/cart/add") === -1) return;
    e.preventDefault();
    var fd = new FormData(form);
    var id = fd.get("id");
    var qty = parseInt(fd.get("quantity") || "1", 10) || 1;
    if (!id) return;
    add(id, qty).catch(function () {
      form.submit();
    });
  });

  refresh();
  window.NNCart = { open: openCart, close: closeCart, refresh: refresh, add: add };
})();
